import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, Divider, FormControl, IconButton, MenuItem, Popover, Select, Stack, TextField, Typography } from '@mui/material'
import { ChevronLeftIcon, ChevronRightIcon, DotIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react'
import { endOfMonth, format, isValid, parse, startOfMonth } from 'date-fns';
import { ApiGetNewBundleList, ApiDeleteBundleAllocation, ApiDeleteNewBundleAllocation, ApiGetShopperList, ApiResetNewBundleAllocation, ApiChangeShopperOfBundle, ApiCopyTransportBundle, ApiGetVisitTimes, ApiBulkAssignShopper, ApiAssignBulkAllocations, ApiGetAllocations } from '../../../apiService/Core/Apicall.tsx';
import { Link, useNavigate } from 'react-router-dom';
import edit from "../../../assets/images/editIcon.png";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store.ts';
import { setDate } from '../../../global/config/Reducer/dateSlice.ts';
import { CancelOutlined, Person2Outlined } from '@mui/icons-material';
import { monthsData } from '../../../global/constants/globalContants.ts';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';
import Dcrage from '../OrphanAllocation/Dcrage.tsx';
import { useShopperDetails } from '../../../global/ShopperDetailsUtils.ts';

function NewBundleAllocation() {

    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch();
    const [task, settask] = React.useState<any>([]);
    const [currentDate, setCurrentDate] = useState(() => {
        const date = new Date(selectedDateRedux);
        date.setMonth(date.getMonth());
        return date;
    }); const [reportMonth, setReportMonth] = useState<number>(currentDate.getMonth() + 1);
    const [reportYear, setReportYear] = useState<number>(currentDate.getFullYear());
    const [open, setOpen] = useState(false);
    const [openChangeShopper, setopenChangeShopper] = useState(false);
    const [copybundle, setCopyBundle] = useState(false);
    const [shopperlist, setshopperlist] = useState([]);
    const [selectedShopper, setSelectedShopper] = useState<any>();
    const [searchShopper, setsearchShopper] = useState<any>([]);
    const [selectedBundles, setSelectedBundles] = useState<number[]>([]);
    const [selectedBundleId, setSelectedBundleId] = useState<number | null>(null);
    const [selectedBundleName, setSelectedBundleName] = useState<string | null>(null);
    const [monthly, setMonthly] = useState([])
    const [visitTimes, setVisitTimes] = useState<any[]>([]);
    const [visitTimesValues, setVisitTimesValues] = useState<any[]>([]);
    const [selectedDate, setSelectedDate] = useState<Date | null>();
    const [selectedAllocations, setSelectedAllocations] = useState<string[]>([]);
    const [selectedbundle, setselectedbundle] = useState<any>([])
    const [assignData, setAssignData] = useState<any[]>([])
    const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
    const [copyAllBundles, setCopyAllBundles] = useState(false);
    const [monthlyForAll, setMonthlyForAll] = useState([]);
    const selectedMonthStart = startOfMonth(new Date(reportYear, reportMonth - 1));
    const selectedMonthEnd = endOfMonth(new Date(reportYear, reportMonth - 1));

    const Navigate = useNavigate()

    const handleGetVisitTimeList = async () => {
        try {
            const response: any = await ApiGetVisitTimes();
            setVisitTimes(response.data);
            console.log("visit times list", response.data);
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };
    useEffect(() => {
        handleGetVisitTimeList()
    }, [])

    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            dispatch(setDate(newDate))
            return newDate;
        });
    };
    const ApiBundleAllocation = async () => {
        settask([]);
        const data = `?month=${reportMonth}&year=${reportYear}`
        try {
            const response = await ApiGetNewBundleList(data)
            settask(response.data)

        } catch (error) {

            alert(error)
        }

    }

    useEffect(() => {
        ApiBundleAllocation()
    }, [reportMonth, reportYear])

    const handleNextMonth = () => {

        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            dispatch(setDate(newDate))
            return newDate;
        });

    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01");

        setCurrentDate(newDate);
        setReportMonth(newDate.getMonth() + 1);
        setReportYear(newDate.getFullYear());
        dispatch(setDate(event.target.value))

    };

    const deleteBundle = async (bundleId: number, newStatus: string) => {
        try {
            const data = `?bundleId=${bundleId}`
            const response: any = await ApiDeleteNewBundleAllocation(data);
            toast.success(response.message);
            ApiBundleAllocation()
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error Deleting Bundle.")
        }
    };

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    const handleCloseDialog = () => {
        setopenChangeShopper(false)
        setselectedbundle([])
        setSelectedShopper(null)
        setSelectedBundleId(null);
    }
    const handleCloseDialog2 = () => {
        setOpen(false)
        setVisitTimesValues([]);
        setSelectedShopper(null)
        setSelectedDate(new Date());
    }

    const getShopperList = async (text: any) => {
        setshopperlist([])
        try {
            const data = `?offset=0&limit=1000${text?.length > 0 ? `&search=${text}` : ''}`
            const res = await ApiGetShopperList(data)
            const originonal = res.data
            setshopperlist(originonal)
        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        getShopperList(searchShopper);
    }, [searchShopper])
    console.log("Seleced SHopper", selectedShopper);

    const handleResetBundle = async () => {
        try {
            const data = `?bundleIds=${selectedBundles.join(",")}`
            const res = await ApiResetNewBundleAllocation(data);
            ApiBundleAllocation()
            toast.success(res.message);
            // const data1 = `?month=${reportMonth}&year=${reportYear}&allocationStatus=ongoing`
            // await ApiGetNewBundleList(data1);
            // set
        } catch (error) {
            console.error("Error Reseting Bundle", error)
            toast.error("Error Reseting Bundle.")
        }
    }

    const handleShopperChange = async () => {
        try {

            // const data = `?userId=${selectedShopper.userId}&bundleId=${selectedBundleId}`
            const data = {
                allocationIds: selectedbundle?.allocations?.map((item: any) => item?.allocationId),
                userId: selectedShopper.userId
            }
            const res = await ApiChangeShopperOfBundle(data)
            toast.success(res.message);
            setselectedbundle([])
            ApiBundleAllocation()
            handleCloseDialog()
        } catch (error) {
            console.error("Error Changing Shopper", error)
            toast.error("Error Changing Shopper.")
        }
    }

    const createCopyBundle = async () => {
        if (monthly?.length > 0) {
            try {
                const data = {
                    withoutVenueBundleAllocationId: selectedBundleId,
                    createdBy: localStorage.getItem('userId'),
                    monthYear: monthly?.map((item) => ({ "month": item, "year": reportYear }))

                }
                const response = await ApiCopyTransportBundle(data);
                if (response.status) {
                    setSelectedBundleId(null)
                    setCopyBundle(false)
                    setMonthly([])
                    ApiBundleAllocation()
                }
            } catch (error) {
                console.log("Error While Creting Error", error)
            }
            finally {
                setSelectedBundleId(null)
                setMonthly([])
                setCopyBundle(false)
            }

        }
        else {
            alert("Please select month to copy bundle")
        }
    }

    const handleBulkAssign = async () => {
        try {
            for (let i = 0; i < assignData.length; i++) {
                const item = assignData[i];

                if (!item.allocationId) {
                    toast.error(`Allocation ID missing at row ${i + 1}`);
                    return;
                }

                if (!item.selectedVisitDate) {
                    toast.error(`Visit Date missing for venue ${i + 1}`);
                    return;
                }

                if (!item.selectedVisitTime) {
                    toast.error(`Visit Time missing for venue ${i + 1}`);
                    return;
                }

                if (!item.userId) {
                    toast.error(`Shopper not selected for venue ${i + 1}`);
                    return;
                }
            }
            // const data = {
            //     AllocationDetails: assignData
            // }
            const data = {
                AllocationDetails: assignData.map((item: any) => ({
                    ...item,
                    selectedVisitDate: item.selectedVisitDate
                        ? (() => {
                            const [day, month, year] = item.selectedVisitDate.split("/");
                            return `${year}-${month}-${day}`;
                        })()
                        : null
                }))
            };
            // console.log("Assign data", data)
            const response = await ApiAssignBulkAllocations(data);
            toast.success(response.message)
            setOpen(false)
            setselectedbundle([])
            setSelectedAllocations([]);
            setVisitTimesValues([]);
            setSelectedShopper(null)
            setSelectedDate(new Date());
            ApiBundleAllocation();
        } catch (error) {
            console.error("Error Assigning Shopper.", error);
            toast.error("Error Assigning Shopper.")
        }
    }
    const handleSelectAll = (checked: boolean) => {
        if (checked) {
            setSelectedBundles(task.map((item: any) => item.bundleId));
        } else {
            setSelectedBundles([]);
        }
    };

    const createCopyAllBundles = async () => {
        if (monthlyForAll?.length > 0) {
            try {
                const data = {
                    bundles: selectedBundles.map((bundleId) => ({
                        withoutVenueBundleAllocationId: bundleId,
                        monthYear: monthlyForAll?.map((item) => ({
                            "month": item,
                            "year": reportYear
                        })),
                        createdBy: localStorage.getItem('userId')
                    }))
                };

                // const response = await ApiCopyTransportBundle(data);
                console.log("Data------->", data);

                // if (response.status) {
                //     setSelectedBundles([]);
                //     setCopyAllBundles(false);
                //     setMonthlyForAll([]);
                //     toast.success("Bundles copied successfully");
                //     ApiBundleAllocation();
                // }
            } catch (error) {
                console.log("Error While Creating Bundles", error);
                toast.error("Error copying bundles");
            } finally {
                setSelectedBundles([]);
                setMonthlyForAll([]);
                setCopyAllBundles(false);
            }
        } else {
            alert("Please select month to copy bundles");
        }
    };


    const handleInviteShopper = async (allocationId: any) => {
        try {
            const data = `?allocationId=${allocationId}`
            const res = await ApiGetAllocations(data)
            if (res?.status) {
                sessionStorage.setItem("inviteShopperState", JSON.stringify(res?.data[0]))
                const url = `/admin/allocations/Invite-Shopper`
                window.open(url, "_blank")
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }
    return (
        <Box className='bg-white pt-5'>
            <h1 className="text-center">Transport Bundle Allocations</h1>
            <div className="d-flex align-items-center justify-content-between px-3 mb-1">

                {/* <Box className='col-6 d-flex juastify-content-start'> */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // marginTop: "20px"
                    }}
                >
                    <IconButton onClick={handlePrevMonth}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                        <input
                            type="month"
                            onChange={handleDateChange}
                            value={format(currentDate, "yyyy-MM")}
                            className="primary-color"
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "1.25rem",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontFamily: "inherit",
                            }}
                        />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
                <Box className='extra d-flex' gap={1}>
                    <Box className='d-flex align-items-center' gap={1}>
                        <Checkbox
                            checked={selectedBundles.length === task.length && task.length > 0}
                            indeterminate={selectedBundles.length > 0 && selectedBundles.length < task.length}
                            onChange={(e) => handleSelectAll(e.target.checked)}
                            sx={{
                                color: "#888",
                                "&.Mui-checked": {
                                    color: "#888",
                                },
                                "& .MuiSvgIcon-root": {
                                    color: "#888",
                                },
                                "&.Mui-checked .MuiSvgIcon-root": {
                                    color: "#1976d2",
                                }
                            }}
                        />
                        <Typography variant='body1' sx={{ fontWeight: "bold" }}>Select All Bundles</Typography>
                    </Box>
                    <Button
                        className="bg-grey transform px-5 text-light mr-1"
                        onClick={() => setCopyAllBundles(true)}
                        disabled={selectedBundles.length === 0}
                    >
                        Copy All Bundles
                    </Button>
                    <Button className="bg-grey transform px-5 text-light mr-1" onClick={() => {
                        handleResetBundle();
                    }}>
                        Reset
                    </Button>
                    <Link
                        to={`/admin/allocations/createOrUpdateNewbundle-allocations`}
                        className="link-btn px-5"
                    // onClick={() => { Navigate('/admin/allocations/createOrUpdateNewbundle-allocations') }}
                    >
                        Create
                    </Link>
                </Box>
            </div>
            <Divider className='mx-4 mb-2' />
            <Box minHeight='calc(100vh - 200px)' className='d-flex align-items-start  justify-content-between'>
                <Box className='col-12 h-100 p-3'>
                    <Box className='d-flex flex-wrap align-items-stretch justify-content-start' gap={2}>
                        {task.map((item: any) => {
                            const uniqueUsers = [
                                ...new Map(
                                    item.allocations
                                        .filter((v: any) => v.userId) // 👈 remove null users first
                                        .map((v: any) => [v.userId.userId, v.userId])
                                ).values()
                            ];
                            return (
                                <Box className='border d-flex align-items-start justify-content-between p-3 col-6' sx={{ borderRadius: '10px' }} maxWidth='49%' gap={1} key={item.bundleId}>

                                    <Box className='d-flex align-items-start' gap={'10px'}>
                                        <Checkbox
                                            checked={selectedBundles.includes(item.bundleId)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedBundles(prev => [...prev, item.bundleId]);
                                                } else {
                                                    setSelectedBundles(prev => prev.filter(id => id !== item.bundleId));
                                                }
                                            }}
                                        />
                                        <Box className='w-100'>
                                            <Box className="d-flex align-items-center">

                                                <Typography lineHeight='1' fontWeight='bold' className='m-0 p-0' variant='h6'>{item.bundleName}</Typography>
                                                {/* <Box> */}

                                                {/* <Button
                                                onClick={() => { Navigate('/admin/allocations/createOrUpdateNewbundle-allocations', { state: { bundleData: item, currentDate: currentDate } }) }}
                                            >
                                                <Box component="img" className="w-50" src={edit}></Box>
                                            </Button> */}
                                                {/* <Button
                                                variant="contained"
                                                className="delete-transparent"
                                                onClick={() => {
                                                    const isConfirmed = window.confirm(
                                                        "Are you sure you want to delete the Site?"
                                                    );
                                                    if (isConfirmed) {
                                                        deleteBundle(Number(item.bundleId), "delete")
                                                    }
                                                }}
                                            >
                                                <DeleteIcon className="delete-icon" />
                                            </Button> */}
                                                {/* </Box> */}
                                            </Box>
                                            <Box className='mt-2 d-flex w-100 justify-content-between' flex={1} flexDirection={"column"}>
                                                <Box className="d-flex" flex={1}>
                                                    <Typography fontWeight={700} variant='subtitle2'>Site:&nbsp;</Typography>
                                                    <ul className='mt-1 w-100 d-flex flex-wrap'>
                                                        {item?.allocations?.map((alloc: any, index: number) => {
                                                            let displayName = "";

                                                            if (alloc.venueId && alloc.venueId?.venueName) {
                                                                displayName = alloc?.venueId?.venueName;
                                                            } else if (alloc.clientEntityId) {
                                                                displayName = `${alloc.clientEntityId.entityName}-${alloc.differentiateKey}`;
                                                            } else {
                                                                displayName = "N/A";
                                                            }

                                                            return (
                                                                <li key={index} className='d-flex col-6'>
                                                                    <span><DotIcon /></span>
                                                                    <Typography
                                                                        whiteSpace='wrap'
                                                                        className='fw-bold m-0 p-0'
                                                                        variant='subtitle2'
                                                                    >
                                                                        {displayName}
                                                                    </Typography>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </Box>
                                                {uniqueUsers?.map((shopper: any) => (
                                                    <Box gap={1} className='d-flex align-items-center mt-2 mb-1' width="fit-content" sx={{ cursor: "pointer" }}
                                                        onClick={(e) => {
                                                            if (shopper?.userId) {
                                                                handleShopperDetailsClick(e, shopper?.userId)
                                                            }
                                                        }}
                                                    >
                                                        <Person2Outlined />
                                                        <Typography variant='body1' className={shopper?.userStatus?.userStatus !== "active" ? "px-2 bg-danger text-white" : ""}>{shopper?.firstName} {shopper?.lastName}</Typography>
                                                    </Box>
                                                ))}
                                                <Popover
                                                    // open={Boolean(anchorEl) && selectedIndex === index}
                                                    open={Boolean(anchorEl) && clickedShopperId !== null}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "center",
                                                    }}
                                                    transformOrigin={{
                                                        vertical: "top",
                                                        horizontal: "center",
                                                    }}
                                                >
                                                    <Dcrage handleClose={handleClose} loanData={loanData} />
                                                </Popover>

                                            </Box>

                                        </Box>
                                    </Box>
                                    <Box gap={1} className="justify-content-end align-items-stertch d-flex flex-column">
                                        {item?.allocations?.some((v: any) => v?.userId === null) && (<Button
                                            variant='contained'
                                            color='primary'
                                            className='table-row-background'
                                            sx={{ whiteSpace: 'nowrap' }}
                                            onClick={() => {
                                                const allocations = item.allocations
                                                    .filter((v: any) => v?.user === null)
                                                    .map((v: any) => v.allocationId)
                                                    .filter((id: any) => id !== null);

                                                setSelectedAllocations(allocations);
                                                setOpen(true)
                                                setselectedbundle(item)
                                                setAssignData(
                                                    item?.allocations?.filter((v: any) => v?.userId === null).map((v: any) => ({
                                                        allocationId: v.allocationId,
                                                        selectedVisitDate: null,
                                                        selectedVisitTime: null,
                                                        userId: null,
                                                    }))
                                                );

                                            }}
                                        >
                                            Assign Shopper
                                        </Button>
                                        )}

                                        {Array.isArray(item?.allocations) &&
                                            item.allocations.length > 0 &&
                                            item?.allocations?.some((v: any) => v?.allocationStatusId?.statusCode !== "completed") &&
                                            item?.allocations?.some((v: any) => v?.userId?.userId) &&
                                            (
                                                <Button
                                                    variant='contained'
                                                    color='primary'
                                                    className='table-row-background'
                                                    sx={{ whiteSpace: 'nowrap' }}
                                                    onClick={() => { setopenChangeShopper(true); setSelectedBundleId(item.bundleId); setselectedbundle(item) }}
                                                >
                                                    Change Shopper
                                                </Button>
                                            )}
                                        <Button
                                            variant='contained'
                                            color='primary'
                                            sx={{ whiteSpace: 'nowrap' }}
                                            className='table-row-background'
                                            onClick={() => { setCopyBundle(true); setSelectedBundleName(item.bundleName); setSelectedBundleId(item.bundleId); }}
                                        >
                                            Copy Bundle
                                        </Button>
                                        <Link
                                            to={`/admin/allocations/createOrUpdateNewbundle-allocations/${currentDate}/${item?.bundleId}`}
                                            // variant='contained'
                                            // color='primary'
                                            className='table-row-background text-center link-btn'
                                        // onClick={() => { Navigate('/admin/allocations/createOrUpdateNewbundle-allocations', { state: { bundleData: item, currentDate: currentDate } }) }}
                                        >
                                            Edit Bundle
                                        </Link>
                                        <Link
                                            to={`/admin/allocations/Invite-Shopper/${item?.allocations[0]?.allocationId}`}
                                            // variant='contained'
                                            // color='primary'
                                            className='table-row-background link-btn text-center'
                                        // onClick={() => {
                                        //     handleInviteShopper(item?.venue[0]?.allocationId)
                                        // }}
                                        >
                                            Invite Shopper
                                        </Link>

                                        {/* <Button
                                            variant='contained'
                                            color='primary'
                                            className='table-row-background'
                                            // onClick={() => { setCopyBundle(true); setSelectedBundleName(item.bundleName); setSelectedBundleId(item.bundleId); }}
                                            onClick={() => {
                                                handleInviteShopper(item?.allocations[0]?.allocationId)
                                            }}
                                        >

                                            Invite Shopper
                                        </Button> */}
                                        <Button
                                            variant="contained"
                                            sx={{ background: "#FF00001A", color: "#FF0000", borderColor: "#FF0000" }}
                                            // className="delete-transparent"
                                            onClick={() => {
                                                const isConfirmed = window.confirm(
                                                    "Are you sure you want to delete the bundle?"
                                                );
                                                if (isConfirmed) {
                                                    deleteBundle(Number(item.bundleId), "delete")
                                                }
                                            }}
                                        >
                                            Delete Bundle
                                            {/* <DeleteIcon className="delete-icon" /> */}
                                        </Button>
                                    </Box>
                                </Box>
                            )
                        })}
                    </Box>
                </Box>
            </Box>
            <Dialog open={open} maxWidth="sm" fullWidth>
                <DialogContent sx={{ height: "fit-content", maxHeight: '' }}>
                    <Box display="flex" alignItems={'center'} justifyContent="space-between">
                        <Typography>{selectedbundle?.bundleName}</Typography>
                        <IconButton onClick={() => handleCloseDialog2()}>
                            <CancelOutlined />
                        </IconButton>
                    </Box>

                    <Autocomplete
                        id="shopper-autocomplete"
                        disablePortal
                        className='mt-3'
                        options={shopperlist?.filter((item: any) => item?.firstName !== "")}
                        value={selectedShopper}
                        onInputChange={(event, newInputValue) => {
                            setsearchShopper(newInputValue);
                            if (newInputValue === "") setSelectedShopper(null);
                        }}
                        getOptionLabel={(option: any) =>
                            `${option?.firstName} ${option?.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                        }
                        isOptionEqualToValue={(option: any, value: any) =>
                            option.userId === value.userId || option.emailId === value.emailId
                        }
                        onChange={(event, newValue: any) => {
                            setSelectedShopper(newValue);
                            setAssignData((prev) =>
                                prev.map((item) => ({
                                    ...item,
                                    userId: newValue.userId,
                                }))
                            );
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Shopper" size="medium" fullWidth />
                        )}
                    />
                    {selectedbundle?.allocations?.filter((v: any) => v?.user == null)?.map((item: any, index: number) => {
                        let displayName = "";
                        // console.log("Selected Bundle", selectedbundle)
                        if (item.venueId && item.venueId?.venueName) {
                            displayName = item.venueId.venueName;
                        } else if (item.clientEntityId) {
                            displayName = `${item.clientEntityId.entityName}-${item.differentiateKey}`;
                        } else {
                            displayName = "N/A";
                        }
                        return (
                            <Stack alignItems="stretch" className='mt-3'>
                                <Typography gutterBottom fontWeight={'bold'}>
                                    {displayName}
                                </Typography>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Select Visit Date"
                                        className='mt-2'
                                        // value={
                                        //     assignData[index]?.selectedVisitDate &&
                                        //         !isNaN(new Date(assignData[index].selectedVisitDate).getTime())
                                        //         ? new Date(assignData[index].selectedVisitDate)
                                        //         : null
                                        // }
                                        value={
                                            assignData[index]?.selectedVisitDate
                                                ? (() => {
                                                    const parsedDate = parse(
                                                        assignData[index].selectedVisitDate,
                                                        "dd/MM/yyyy",
                                                        new Date()
                                                    );

                                                    return isValid(parsedDate) ? parsedDate : null;
                                                })()
                                                : null
                                        }
                                        minDate={selectedMonthStart}
                                        maxDate={selectedMonthEnd}
                                        onChange={(newDate) => {
                                            const isValidDate = newDate && !isNaN(new Date(newDate).getTime());
                                            const formattedDate = isValidDate
                                                ? format(newDate, "dd/MM/yyyy")
                                                : null;

                                            setAssignData((prev) =>
                                                prev.map((d, i) =>
                                                    i === index
                                                        ? { ...d, selectedVisitDate: formattedDate }
                                                        : d
                                                )
                                            );
                                        }}
                                        format="dd/MM/yyyy"
                                        slotProps={{
                                            textField: {
                                                size: "medium",
                                                fullWidth: true,
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                                <Autocomplete
                                    options={visitTimes}
                                    disableCloseOnSelect
                                    className='mt-2'
                                    getOptionLabel={(option) => option.visitTimeInformation}
                                    value={
                                        visitTimes.find(
                                            (t) => t.visitTimeId.toString() === assignData[index]?.selectedVisitTime
                                        ) || null
                                    }
                                    // onChange={(event, newValue) => {
                                    //     setVisitTimesValues(
                                    //         newValue.map((item) => item.visitTimeId.toString())
                                    //     );
                                    // }}
                                    onChange={(event, newValue) => {
                                        setAssignData((prev) =>
                                            prev.map((d, i) =>
                                                i === index
                                                    ? {
                                                        ...d,
                                                        selectedVisitTime: newValue
                                                            ? newValue.visitTimeId.toString()
                                                            : null,
                                                    }
                                                    : d
                                            )
                                        );
                                    }}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.visitTimeInformation}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Visit Times" size="medium" fullWidth />
                                    )}
                                />
                            </Stack>
                        )
                    })}

                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background p-3"
                        onClick={() => {
                            const isConfirmed = window.confirm("Are You Sure You Want Assign Shopper ?")
                            if (isConfirmed) {
                                handleBulkAssign()
                            }
                        }}
                    >
                        Assign Shopper
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openChangeShopper} maxWidth="sm" fullWidth>
                <DialogContent sx={{ height: "150px" }}>
                    <Box display="flex" alignItems={'center'} justifyContent="space-between">
                        <Typography variant='h6'>{selectedbundle?.bundleName}</Typography>
                        <IconButton onClick={() => handleCloseDialog()}>
                            <CancelOutlined />
                        </IconButton>
                    </Box>
                    <Stack alignItems="stretch" mt={3}>
                        <Autocomplete
                            id="shopper-autocomplete"
                            sx={{ zIndex: 99999 }}
                            // disablePortal
                            options={shopperlist?.filter((item: any) => item?.firstName !== "")}
                            value={selectedShopper}
                            onInputChange={(event, newInputValue) => {
                                setsearchShopper(newInputValue);
                                if (newInputValue === "") setSelectedShopper(null);
                            }}
                            getOptionLabel={(option: any) =>
                                `${option?.firstName} ${option?.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                            }
                            isOptionEqualToValue={(option: any, value: any) =>
                                option.userId === value.userId || option.emailId === value.emailId
                            }
                            onChange={(event, newValue: any) => setSelectedShopper(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Shopper" size="medium" fullWidth />
                            )}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions className='mt-0'>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background p-3"
                        onClick={() => {
                            handleShopperChange()
                        }}
                    >
                        Change Shopper
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={copybundle}>
                <DialogContent className='d-flex flex-column' sx={{ height: "fit-content", width: 'fit-content' }}>
                    <Box gap={5} className='d-flex align-items-center mb-3 justify-content-between'>
                        <Typography variant='h6' fontWeight={700}>{selectedBundleName}</Typography>
                        <IconButton className='p-0 m-0' onClick={() => { setMonthly([]); setSelectedBundleId(null); setCopyBundle(false) }}><CancelOutlined /></IconButton>
                    </Box>
                    <FormControl className='mx-auto' size="small" sx={{ minWidth: 400 }}>
                        <Select
                            // style={{ width: "200px" }}
                            fullWidth
                            className='mb-1'
                            multiple
                            value={monthly}
                            displayEmpty
                            onChange={(event: any) => {
                                setMonthly(event.target.value)
                            }}
                            renderValue={(selected) =>
                                selected.length === 0
                                    ? "Months"
                                    : selected.map((id) => monthsData.find((m) => m.id === id)?.label).join(", ")
                            }
                        >
                            {monthsData.map((items) => (
                                <MenuItem key={items.id} value={items.id}>
                                    {items.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Button
                        onClick={() => { createCopyBundle() }}
                        variant='contained'
                        color='primary'
                        className='table-row-background mt-2'>Copy</Button>
                </DialogContent>
            </Dialog>
            <Dialog open={copyAllBundles}>
                <DialogContent className='d-flex flex-column' sx={{ height: "fit-content", width: 'fit-content' }}>
                    <Box gap={5} className='d-flex align-items-center mb-3 justify-content-between'>
                        <Typography variant='h6' fontWeight={700}>Copy Selected Bundles ({selectedBundles.length})</Typography>
                        <IconButton className='p-0 m-0' onClick={() => {
                            setMonthlyForAll([]);
                            setCopyAllBundles(false);
                            setSelectedBundles([]);
                        }}>
                            <CancelOutlined />
                        </IconButton>
                    </Box>
                    <FormControl className='mx-auto' size="small" sx={{ minWidth: 400 }}>
                        <Select
                            fullWidth
                            className='mb-1'
                            multiple
                            value={monthlyForAll}
                            displayEmpty
                            onChange={(event: any) => {
                                setMonthlyForAll(event.target.value)
                            }}
                            renderValue={(selected) =>
                                selected.length === 0
                                    ? "Select Months"
                                    : selected.map((id) => monthsData.find((m) => m.id === id)?.label).join(", ")
                            }
                        >
                            {monthsData.map((items) => (
                                <MenuItem key={items.id} value={items.id}>
                                    {items.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Button
                        onClick={() => { createCopyAllBundles() }}
                        variant='contained'
                        color='primary'
                        className='table-row-background mt-2'
                    >
                        Copy All
                    </Button>
                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default NewBundleAllocation;
